import type { WriteRejection } from "@estelle/domain";

/**
 * One line describing why a write was refused.
 *
 * Mirrors `@/modules/catalog/writeRejection` — this module owns its own copy
 * rather than importing across a module boundary another agent is actively
 * building in, but the shape has to match: a `conflict` should read the same
 * way whether it came from an HSN edit or a tag edit. The switch has no
 * `default` on purpose — a sixth rejection kind added to the union in
 * `@estelle/domain` fails this file at compile time instead of silently
 * describing it as nothing.
 */
export function describeRejection(rejection: WriteRejection): string {
  switch (rejection.kind) {
    case "blocked":
    case "channel_rejected":
      return rejection.message;
    case "conflict":
      return `${rejection.message} It changed at ${rejection.currentUpdatedAt}.`;
    case "forbidden":
      return `${rejection.message} (requires ${rejection.permission})`;
    case "invalid":
      return rejection.fields
        ? `${rejection.message} ${Object.entries(rejection.fields)
            .map(([field, problem]) => `${field}: ${problem}`)
            .join("; ")}`
        : rejection.message;
  }
}
